import {observable,action} from 'mobx';
import {arrDiff} from "../utils/util";
const commentApi = require("../actions/comment");

export default class CommentStore{
    @observable commentList = [];
    @observable commentTop = [];
    @observable myCommentList = [];
    @observable topCommentList = [];
    @observable total = 0;
    @observable lastTime = Number.MAX_SAFE_INTEGER;
    @observable minCreateTime = new Date().getTime(); // 最小的创建时间，注意，加载更多是加载老的评论，而默认的刷新是加载最新的评论
    @observable commentLoadAll = false; //评论是否已经加载完
    constructor(rootStore){
        this.rootStore = rootStore;
    }
    @action addOne(one){
        this.commentList = [one,...this.commentList];
    }
    @action addOneMy(one){
        this.myCommentList = [one,...this.myCommentList];
    }
    @action deleteOneById = (id)=>{
        if(!id){
            return;
        }
        const index = this.commentList.findIndex(one=>one.id==id);
        if(index !== -1){
            this.commentList = [
                ...this.commentList.slice(0,index),
                ...this.commentList.slice(index+1),
            ]
        }

    }
    @action deleteOneMyById = (id)=>{
        if(!id){
            return;
        }
        const index = this.myCommentList.findIndex(one=>one.id==id);
        if(index !== -1){
            this.myCommentList = [
                ...this.myCommentList.slice(0,index),
                ...this.myCommentList.slice(index+1),
            ]
        }
    }
    getTop(galleryId) {
        return commentApi.top(galleryId).then(action(jsonData=>{
            if(jsonData && jsonData.data){
                this.topCommentList = jsonData.data;
                return this.topCommentList;
            }
        }))
    }
    getList(galleryId){
        return commentApi.list(galleryId,this.lastTime).then(action(jsonData=>{
            if(jsonData && jsonData.data){
                const sublength = jsonData.data.length;
                const {total} = jsonData;
                this.total = total;
                // console.log(total);
                //现在有前端的前置评论了，必须得考虑去重问题
                this.commentList = [
                    ...arrDiff(this.commentList.slice(),jsonData.data,(a1,a2)=>{return a1.id === a2.id}),
                    ...jsonData.data
                ];
                const {length} = this.commentList;
                // 认定如果返回的数量是0 或者返回的数量和 commentList一样 说明已经加载完所有评论
                // （不考虑后来新增的评论，反正不定期的在刷新评论）
                if(length === total || sublength < 50){
                    this.commentLoadAll = true;
                }
                if(length){
                    // this.lastTime = this.commentList[0].createtime || 0;
                    this.minCreateTime = this.commentList[length-1].createtime;
                    this.lastTime = this.commentList[length-1].createtime;
                }
                //console.log(this.commentList.slice())
                return this.commentList;
            }
        }))
    }
    getMyList(galleryId){
        if(window.islogin) {
            return commentApi.my(galleryId).then(action(jsonData=>{
                if(jsonData && jsonData.data){
                    //我的评论没有 评论列表的最后时间的概念，每次获取都是全量获取，所以直接就覆盖原来的值
                    this.myCommentList = jsonData.data || []
                    return this.myCommentList;
                }

            }))
        }
        return [];
    }
    @action clear(){
        this.lastTime = Number.MAX_SAFE_INTEGER;
        this.commentList = [];
        this.myCommentList = [];
    }
}



// WEBPACK FOOTER //
// ./src/store/CommentStore.js